<template>
  <div class="latest-news">
    <div class="page-help content">
      <div class="title">
        <h2>{{ $t("newHome.latestNews") }}</h2>
        <router-link
          class="btn link"
          :to="{ name: 'News', params: { lang: $i18n.locale } }"
          >{{ $t("newHome.seeAllNews") }}
          <img src="../../assets/newImges/Arrow.svg" alt="go"
        /></router-link>
      </div>
      <!-- <OneNews v-for="(onenews, index) in news" :key="index" :onenews="onenews" /> -->
      <OneNews v-if="news[0]" :onenews="news[0]" />
      <OneNews v-if="news[1]" :onenews="news[1]" />
    </div>
  </div>
</template>
<script>
import OneNews from "@/components/news/newOneNews.vue";

import { api, baseURL } from "@/api";

export default {
  components: { OneNews },
  data() {
    return {
      news: [],
      page: 1,
      pageCount: 2
    };
  },
  methods: {
    getNews() {
      let params = {
        page: this.page,
        page_count: this.pageCount
      };
      api
        .getNews(params)
        .then(res => {
          this.news = res.data.data;
          this.pageCount = res.data.page_count;
        })
        .catch(e => {
          console.log(e);
        });
    },
    getPaginationImages(side) {
      let path = require(`@/assets/icons/pagination${side}.png`);
      return `<img src='${path}' alt='pagination left image'>`;
    },
    changePage(page) {
      this.page = page;
      this.news = [];
      this.getNews();
    }
  },
  mounted() {
    this.getNews();
  }
};
</script>
<style lang="scss">
.latest-news {
  width: 100%;
  background-color: $gray-blue-400;
  padding-bottom: 173px;
  padding-top: 173px;
  font-family: Outfit;

  .content {
    display: flex !important;
    justify-content: space-between;
    flex-wrap: wrap;
    .title {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-bottom: 58px;
      h2 {
        font-weight: 600;
        font-style: SemiBold;
        font-size: 36px;
        line-height: 66px;
        letter-spacing: 0%;
        color: $blue-1000;
        margin: 0;
      }
      .link {
        text-decoration: none;
        background-color: $blue-600;
        width: 187px;
        font-weight: 500;
        font-style: Medium;
        font-size: 18px;
        line-height: 26px;
        letter-spacing: 0%;
        border-radius: 10px;
      }
    }
  }
}
@media only screen and (max-width: 768px) {
  .latest-news {
    padding-bottom: 73px;
    padding-top: 73px;
    .content {
      .title {
        flex-direction: column;
        margin-bottom: 28px;
        text-align: left;
      }
    }
  }
  .newOneNews {
    max-width: 100% !important;
    margin-bottom: 30px;
  }
}
</style>
